import { ArgsType, Field } from '@nestjs/graphql'

@ArgsType()
export class DateArgs {
  @Field(type => Date, { nullable: true })
  date?: Date
}
